<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <label class="generalLabel" for="vendorCheck">Se ha creado el registro correctamente.</label>
    <button class="btn btn-primary generalPrimaryButton float-right" data-dismiss="modal" aria-label="Close">Confirmar</button>
  </Modal>
</template>

<script>

import Modal from '../../Shared/Modal.vue';
export default {
  name: 'UserCreate',
  props: [
    'id',
    'modalTitle',
    'class',
  ],
  data() {
    return {
      classes: this.class,
    }
  },
  components: {
    Modal,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
